<template>
  <aside
    v-if="visibleBanner"
    class="pw-spot"
    :class="spotClasses"
    aria-label="Współpraca"
  >
    <div ref="bannerContent" class="pw-spot__html" v-html="visibleBanner.html"></div>
  </aside>
</template>

<script>
import {
  ADSENSE_STRIP_WAIT_MS,
  adsenseHasVisibleCreative,
  ensureAdsenseReady,
  isAdsenseBanner,
  requestAdsenseFill
} from '@/adsense'

export default {
  props: {
    banner: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      adsensePending: false,
      adsenseFailed: false,
      adsenseObserver: null,
      adsenseTimer: 0,
      adsenseStarted: false
    }
  },
  computed: {
    visibleBanner () {
      if (!this.banner || !this.banner.html || this.adsenseFailed) {
        return null
      }
      return this.banner
    },
    spotClasses () {
      const classes = ['pw-spot--' + (this.banner && this.banner.slot ? this.banner.slot : 'slot')]
      if (this.visibleBanner && (this.visibleBanner.kind === 'adsense' || this.visibleBanner.kind === 'html')) {
        classes.push('pw-spot--network')
      }
      if (this.visibleBanner && this.visibleBanner.kind === 'adsense') {
        classes.push('pw-spot--adsense')
      }
      if (this.adsensePending) {
        classes.push('pw-spot--pending')
      }
      return classes
    }
  },
  watch: {
    banner (banner) {
      this.adsenseFailed = false
      this.adsenseStarted = false
      this.adsensePending = Boolean(banner && isAdsenseBanner(banner))
      if (this.adsensePending) {
        this.$nextTick(() => this.waitForAdsenseFill())
      }
    }
  },
  mounted () {
    if (this.adsensePending) {
      this.waitForAdsenseFill()
    }
  },
  beforeDestroy () {
    this.stopAdsenseWatch()
  },
  methods: {
    stopAdsenseWatch () {
      if (this.adsenseObserver) {
        this.adsenseObserver.disconnect()
        this.adsenseObserver = null
      }
      if (this.adsenseTimer) {
        window.clearTimeout(this.adsenseTimer)
        this.adsenseTimer = 0
      }
    },
    waitForAdsenseFill () {
      if (this.adsenseStarted) {
        return
      }
      this.adsenseStarted = true
      this.stopAdsenseWatch()
      const root = this.$refs.bannerContent
      if (!root) {
        this.adsenseFailed = true
        this.adsensePending = false
        return
      }
      ensureAdsenseReady().then(() => {
        if (!this.adsensePending) {
          return
        }
        requestAdsenseFill(root)
        const ins = root.querySelector('ins.adsbygoogle')
        if (!ins) {
          this.adsensePending = false
          return
        }
        const inspect = () => {
          if (ins.getAttribute('data-ad-status') === 'unfilled') {
            this.adsenseFailed = true
            this.adsensePending = false
            return true
          }
          if (adsenseHasVisibleCreative(ins) || ins.getAttribute('data-ad-status') === 'filled') {
            this.adsensePending = false
            return true
          }
          return false
        }
        if (inspect()) {
          return
        }
        if (window.MutationObserver) {
          this.adsenseObserver = new MutationObserver(inspect)
          this.adsenseObserver.observe(ins, { attributes: true, attributeFilter: ['data-ad-status'] })
        }
        this.adsenseTimer = window.setTimeout(() => {
          if (adsenseHasVisibleCreative(ins) || ins.getAttribute('data-ad-status') === 'filled' || ins.querySelector('iframe')) {
            this.adsensePending = false
          } else {
            this.adsenseFailed = true
            this.adsensePending = false
          }
        }, ADSENSE_STRIP_WAIT_MS)
      })
    }
  }
}
</script>
